import React from "react";
import { Link, useNavigate } from 'react-router-dom';

const Guide = (props) => {

    return (
        <div className="container contents-wrapper">
            <div className="contents-wrapper-width">
                <h1 className="page-title">가이드</h1>
            </div>
        </div>
    );
}
export default Guide;